import styled from 'styled-components'

export const DRAWER = 'drawer'

export const StyledDrawerContainer = styled.div<{ timeout: number; backgroundColor: string, fullHeight: boolean }>`
	position: absolute;
	background-color: ${({ backgroundColor }) => backgroundColor};
	width: 100%;
	height: ${({ fullHeight }) => fullHeight ? '100%' : 'clamp(80vh, 650px, 90vh)'};
	display: flex;
	flex-direction: column;
	bottom: 0;
	border-radius: 12px 12px 0 0;
	transform: translateY(100%);
	opacity: 0;
	transition: ${({ timeout }) =>
		`transform ${timeout}ms cubic-bezier(0.1, 1.001, 0.8, 1.001), opacity ${timeout}ms ease;`};
`
export const StyledMask = styled.div<{ position: 'absolute' | 'fixed' }>`
	position: ${({ position }) => position};
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 6;
	&.enter-done {
		background-color: rgb(0, 0, 0, 0.5);
		.${DRAWER} {
			transform: translateY(0);
			opacity: 1;
		}
	}
`
